export enum MedicationAuditSourceScreen {
    UnitDose = 1,
    DispenseMedications = 2,
}